import React from 'react';

import {Marker} from 'react-map-gl';
import { useSelector } from 'react-redux';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const size = 40;

export const OriginDestMarkers = ({
  enableClick,
  disableClick,
  setMarker
}) => {
  
  let markers = [];
  
  const stateOrigin = useSelector(state => state.directions.origin.marker);
  const stateDestination = useSelector(state => state.directions.destination.marker);

  const originLng = Array.isArray(stateOrigin) && stateOrigin.length > 1 ? stateOrigin[0]: null;
  const originLat = Array.isArray(stateOrigin) && stateOrigin.length > 1 ? stateOrigin[1]: null;
  const destinationLng = Array.isArray(stateDestination) && stateDestination.length > 1 ? stateDestination[0]: null;
  const destinationLat = Array.isArray(stateDestination) && stateDestination.length > 1 ? stateDestination[1]: null;


  if (originLng !== null && originLat !== null) {
    markers.push(
      <Marker 
        id='origin-marker' 
        key='origin' 
        anchor="bottom" 
        longitude={originLng} 
        latitude={originLat} 
        draggable={true} 
        style={{
          zIndex: 10
        }}
        onDragStart={disableClick}
        onDragEnd={(event) => {
          enableClick();
          setMarker([event.lngLat.lng, event.lngLat.lat], 'origin');

        }}
      >
        <FontAwesomeIcon 
          id='origin-marker-icon' 
          icon={faMapMarkerAlt} 
          color='green' 
          style= {{fontSize: `${size}px`}}
        />
      </Marker>
    );
  }

  if (destinationLng !== null && destinationLat !== null) {
    markers.push(
      <Marker 
        id='dest-marker' 
        key='destination' 
        anchor="bottom" 
        longitude={destinationLng}
        latitude={destinationLat}
        draggable={true}
        style={{
          zIndex: 10
        }}
        onDragStart={disableClick}
        onDragEnd={(event) => {
          enableClick();
          setMarker([event.lngLat.lng, event.lngLat.lat], 'destination');
        }}
      >
        <FontAwesomeIcon 
          id='dest-marker-icon' 
          icon={faMapMarkerAlt} 
          color='blue' 
          style= {{fontSize: `${size}px`}}
        />
      </Marker>
    );
  }

  return (
    <div>
      {markers}
    </div>
  );
};